import React from 'react';

interface VenereAnalysisProps {
  size?: number;
  color?: string;
  className?: string;
}

const VenereAnalysis: React.FC<VenereAnalysisProps> = ({ size = 24, color = 'currentColor', className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 2000 2000"
    fill={color}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1263.17,263.11h-526.35c-87.05,0-157.9,70.86-157.9,157.9s70.86,157.9,157.9,157.9v894.79c0,145.08,118.1,263.17,263.17,263.17s263.17-118.1,263.17-263.17v-315.81c0-29.08-23.55-52.63-52.63-52.63s-52.63,23.55-52.63,52.63v315.81c0,87.05-70.86,157.9-157.9,157.9s-157.9-70.86-157.9-157.9v-631.62h315.81v105.27c0,29.08,23.55,52.63,52.63,52.63s52.63-23.55,52.63-52.63v-368.44c87.05,0,157.9-70.86,157.9-157.9s-70.86-157.9-157.9-157.9ZM1263.17,473.65h-52.63c-29.08,0-52.63,23.55-52.63,52.63v210.54h-315.81v-210.54c0-29.08-23.55-52.63-52.63-52.63h-52.63c-29.02,0-52.63-23.62-52.63-52.63s23.62-52.63,52.63-52.63h526.35c29.02,0,52.63,23.62,52.63,52.63s-23.62,52.63-52.63,52.63ZM1090.01,1067.89c9.47,10,15.26,23.68,15.26,37.37s-5.79,27.37-15.26,37.37c-10,9.47-23.68,15.26-37.37,15.26s-27.37-5.26-37.37-15.26c-9.47-10-15.26-23.68-15.26-37.37s5.79-27.37,15.26-37.37c20-19.47,55.27-19.47,74.74,0h0ZM984.74,1278.43c10,10,15.26,23.68,15.26,37.37s-5.79,27.37-15.26,37.37c-10,9.47-23.68,15.26-37.37,15.26s-27.37-5.79-37.37-15.26c-9.47-10-15.26-23.16-15.26-37.37s5.79-27.37,15.26-37.37c19.47-19.47,55.27-19.47,74.74,0h0Z"/>
  </svg>
);

export default VenereAnalysis; 